function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQueueOffHookInbound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.1,6.88c-1.57.91-2.34,2.78-2.26,5.35A15.64,15.64,0,0,0,9,19.13a15.45,15.45,0,0,0,4.79,5.31c2.08,1.4,4.15,1.64,5.76.75h0l1.08-.68A1.05,1.05,0,0,0,21,23.13L19,19.51a1.07,1.07,0,0,0-1.39-.38l-1.13.59c-.49.28-2.46.22-4-2.59s-.76-4.48-.19-4.79l1.15-.58a1.05,1.05,0,0,0,.37-1.39l-2-3.58a1.06,1.06,0,0,0-1.39-.38C10.26,6.24,9.1,6.88,9.1,6.88Z",
    style: {
      fill: "#7e7e7e"
    }
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "17.77 13.96 24.02 14.31 22.58 12.46 25.17 10.44 22.99 7.65 20.4 9.66 18.96 7.8 17.77 13.96",
    style: {
      fill: "#00a6e7"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueueOffHookInbound);
export default __webpack_public_path__ + "static/media/queue-off-hook-inbound.de77f33e.svg";
export { ForwardRef as ReactComponent };